<template>
	<div class="event-speakers page">
		<v-skeleton-loader
			style="max-width: 600px"
			v-bind="attrs"
			type="card"
			v-if="this.isLoading"
		>
		</v-skeleton-loader>
		<div v-else>
			<ButtonBack />
			<div class="event-speakers__search">
				<input
					v-model="filters.search"
					class="event-speakers__search-input"
					type="text"
					placeholder="Search"
					@input="filterSearching"
				/>
				<Icon type="search" :size="26" color="#8E8E93" />
			</div>
			<FilterChipButton
				v-if="chipsList.length"
				:isButtonActive="isButtonActive"
				:chipsList="chipsList"
				:clearFilter="clearFilter"
				@handleChipClick="handleChipClick"
			/>
			<div v-if="filterModalIsVisible">
				<FilterModal
					:filterModalIsVisible="filterModalIsVisible"
					:currentModalFilter="currentModalFilter"
					:currentModalLabel="currentModalLabel"
					:selectedChips="selectedChips"
					:filters="filters"
					:dateError="date.error"
					:dateOption="date.option"
					:dateRange="date.selectedRange"
					@closeModal="closeModal"
					@applySelection="applySelection"
					@setItem="setItem"
				/>
			</div>
			<NewsFeedEmpty
				v-if="!eventSpeakers.length"
				title="No speakers found."
				description="Check back later or use search."
			/>
			<div v-else>
				<h2 class="event-speakers__title">Speakers</h2>
				<EventSpeakerCard
					v-for="speaker in eventSpeakers"
					:key="speaker.speaker_id"
					:speaker="speaker"
				/>
			</div>

			<div
				class="d-flex my-9 justify-center event-speakers__pagination"
				v-if="!isLoading && eventSpeakers.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.eventSpeakersMeta.pageCount"
					v-on:pageChange="onPageChange"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import ButtonBack from '@/components/ButtonBack'
import Pagination from '@/components/Pagination'
import EventSpeakerCard from '@/components/Event/EventSpeakerCard'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Dwh from '@/mixins/Dwh'
import { mapActions, mapGetters } from 'vuex'
import Filter from '@/mixins/Filter'
import FilterModal from '@/components/Modals/FilterModal.vue'
import FilterChipButton from '@/components/FilterChipButtons.vue'

const DEBOUNCE_TIMEOUT = 500

export default {
	components: {
		FilterModal,
		FilterChipButton,
		ButtonBack,
		Pagination,
		EventSpeakerCard,
		NewsFeedEmpty,
	},
	mixins: [Dwh, Filter],
	data() {
		return {
			searchText: '',
			filters: {
				page: 1,
			},
			attrs: {
				class: 'mb-6',
				elevation: 0,
			},
			timer: 0,
		}
	},
	methods: {
		...mapActions('event', ['getEventSpeakersById', 'clearEventSpeakers']),
		...mapActions('app', ['setSearch', 'clearSearch']),
		filterSearching(e) {
			this.setSearch(e.target.value)
		},
	},
	watch: {
		$route() {
			this.searchText = ''
			this.clearSearch()
		},
	},
	computed: {
		...mapGetters('event', ['eventSpeakers', 'eventSpeakersMeta', 'isLoading', 'event']),
	},
	created() {
		this.getEventSpeakersById(this.requestQuery)
		this.sendTrigger({
			category: 'Content',
			action: 'view_speakers_list_event',
			module: 'Events',
			data: this.$route.params.id,
			content_chapter_id:
				this.event && this.event.chapter_id ? [this.event.chapter_id] : null,
		})
	},
	beforeDestroy() {
		this.clearEventSpeakers()
	},
}
</script>
<style lang="scss">
.event-speakers {
	font-family: Montserrat, sans-serif;

	&__title {
		font-size: 24px;
		font-weight: 700;
		color: #4a4a4a;
		line-height: 29.26px;
		margin-bottom: 20px;
		margin-top: 20px;
	}

	&__search {
		display: flex;
		flex-wrap: nowrap;
		padding: 12px 14px;
		background: #fff;
		border: 1px solid #e2e2e2;
		border-radius: 10px;
		margin: 30px 0;

		&-input {
			flex-grow: 1;
			outline: none;
			font-size: 16px;
			font-weight: 400;
			color: #697583;
			line-height: 19.5px;
		}
	}
}
</style>
